export const SET_LOADING_GENERAL = "MAIN_SET_LOADING_GENERAL";
export const UNSET_LOADING_GENERAL = "MAIN_UNSET_LOADING_GENERAL";
export const SET_LOADING_AUTH = "MAIN_SET_LOADING_AUTH";
export const UNSET_LOADING_AUTH = "MAIN_UNSET_LOADING_AUTH";